<template>
    <div class="wraps">
        <div class="top_banner">
            <a class="fanyi-img-link" @click="toback">
                <!-- <img src="@img/96.png" alt class="fanyi-logo" /> -->
                
            </a>
            <a class="fanyi-text-link" @click="toback">返回</a>
        </div>
        <div class="top-title">用户使用协议</div>
        <div class="agreement-content" v-html="news_content"></div>
    </div>
</template>
<script>
import { group_sign, getCookie } from '../../utils/tool';
export default {
  data() {
    return {
      news_content: "",
      account_id:Number(getCookie('account_id')),
    };
  },
  methods: {
      toback(){
          this.$router.go(-1);
      },
    getRichContent() {
      let that = this;
      var param = group_sign({account_id: that.account_id,type: 3})
      this.$axios.post(this.$Api.apiGetUserAgreement,param).then(
        res => {
          if (res.data.errcode == 0) {
            that.news_content = that.htmlDecode(res.data.result.content);
          } else {
            that.news_content = res.data.errmsg;
          }
        }
      ).catch(error => {});
    },
    htmlDecode(str) {
      var s = "";
      if (str.length === 0) return "暂无详情";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&#39;/g, '"');
      s = s.replace(/&quot;/g, '"');
      return s;
    }
  },
  beforeMount() {
    this.getRichContent();
  }
};
</script>
<style lang="less" scoped>
.wraps{
    width: 982px;
    margin: 0 auto;
    padding: 0;
    text-align: left;
    .top_banner {
        width: 982px;
        height: 75px;
        position: relative;
        color: #333333;
        .fanyi-img-link {
            display: inline-block;
            height: 40px;
            position: absolute;
            bottom: 11px;
            text-decoration: none;
            font-size: 18px;
            color: #333;
            .fanyi-logo {
                width: 40px;
                height: 40px;
                border: 0;
                padding: 0;
            }
        }
        .fanyi-text-link {
            float: right;
            display: inline-block;
            position: absolute;
            bottom: 18px;
            right: 2px;
            font-size: 16px;
        }
    }
    .top-title {
        width: 982px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        padding: 0;
        color: #fff;
        background-color: #2f58d8;
        font-weight: 600;
        font-size: 13px;
    }
    .agreement-content {
        margin: 0;
        padding: 22px 0px;
    }
}
</style>